import React, { useEffect, useState } from "react";

function ScrollToTopButton() {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            border: "none",
            background: "#ff6b35",
            color: "#fff",
            fontSize: "22px",
            cursor: "pointer",
            zIndex: 9999,
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          }}
        >
            <i className="bi bi-arrow-up-short"></i>
        </button>
      )}
    </>
  );
}

export default ScrollToTopButton;